import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { Sidenav } from '../Sidenav'
import { useLocation } from 'react-router-dom'

interface WrapperProps {
  noWrapperRoutes?: string[]
  children: JSX.Element
}

interface ConditionalWrapperProps {
  children: JSX.Element
  wrapper: (children: JSX.Element) => JSX.Element
}

const ConditionalWrapper = ({ wrapper, children }: ConditionalWrapperProps) => {
  // Hide nav when screen is widgetized i.e. Zendesk 400px
  const isWidgetScreenWidth = useMediaQuery({ maxWidth: 400 })
  const isWidgetDeviceWidth = useMediaQuery({ maxDeviceWidth: 400 })
  const isWidgetized = isWidgetScreenWidth || isWidgetDeviceWidth

  return !isWidgetized ? wrapper(children) : children
}

export function Wrapper({ noWrapperRoutes = [], children }: WrapperProps) {
  const location = useLocation()

  if (noWrapperRoutes.find((route) => location.pathname === route)) {
    return children
  }

  return (
    <ConditionalWrapper wrapper={(items) => <Sidenav>{items}</Sidenav>}>
      {children}
    </ConditionalWrapper>
  )
}
